.headerRow {
  display: flex;
  justify-content: center;
}

.headerRowEven {
  composes: headerRow;
  background-color: #f5f5f7;
}

.repaymentRow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.end {
  flex: 1;
  padding: 2rem 0;
  justify-content: center;
  align-items: center;
}

.tableTextView {
  display: flex;
  flex: 1;
  border: 0.3px solid #e0e0e0;
  padding: 0.25rem 0.35rem;
  justify-content: center;
}

.repaymentTable {
  display: flex;
  flex-direction: column;
}
